module.exports = __webpack_public_path__ + "03_bob_brown.be43796b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_bob_brown.png
// module id = AYLj
// module chunks = 0